import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  VideoCategory,
  VideoCategoryState
} from '@/modules/teaching/videosCategory/types/types.ts'

const initialState: VideoCategoryState = {
  selected: undefined,
  isOpenModal: false,
  isDeleteModalOpen: false
}

const videoCategorySlice = createSlice({
  name: 'videoCategory',
  initialState,
  reducers: {
    setSelected: (state, action: PayloadAction<VideoCategory | undefined>) => {
      state.selected = action.payload
    },
    setOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenModal = action.payload
    },
    setDeleteOpenModal: (state, action: PayloadAction<boolean>) => {
      state.isDeleteModalOpen = action.payload
    }
  }
})

export const videoCategoryActions = videoCategorySlice.actions
export const { reducer: videoCategoryReducer } = videoCategorySlice
